export const KEY_STORE_DRAFT = "backoffice_draft";
